import { render, staticRenderFns } from "./ShortcutBoard.vue?vue&type=template&id=4f5dcea3&scoped=true"
import script from "./ShortcutBoard.vue?vue&type=script&lang=js"
export * from "./ShortcutBoard.vue?vue&type=script&lang=js"
import style0 from "./ShortcutBoard.vue?vue&type=style&index=0&id=4f5dcea3&prod&scoped=true&lang=css"
import style1 from "./ShortcutBoard.mobile.css?vue&type=style&index=1&id=4f5dcea3&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5dcea3",
  null
  
)

export default component.exports